import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const bankruptcyDate: AnswerPathTreeNode = { path: 'bankruptcyDate ', nodeId: NodeIds.insuredBankruptcyDate };
